module.exports = __webpack_public_path__ + "static/sec4-bg-sm-5b5b951f8f16d7603008deaa5a729745.jpg";